import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["textTag", "blacklistedDates", "blacklistStatus", "datesHiddenField", "cancelEditWarningBtn", "editWarningBtn"];

  connect() {
    this.initializeDatePicker();
    document.querySelector('.edit_drug_test_request_schedule').addEventListener('submit', this.showWarningPopUp.bind(this));
    this.setupTooltips();
    document.querySelector('#drug_test_request_recurrence_rule').addEventListener('change', this.recurringSelectDropdown.bind(this));
  }

  addDate(event) {
    event.preventDefault();

    const date = this.textTagTarget.value;

    if (this.isDateAlreadyBlacklisted(date)) {
      alert("This date is already blacklisted.");
      return;
    }

    if (date) {
      this.appendBlacklistedDate(date);
    }
    $(this.textTagTarget).val('');
  }

  isDateAlreadyBlacklisted(date) {
    let existingDates = [];

    try {
      existingDates = JSON.parse(this.datesHiddenFieldTarget.value);
    } catch (error) {
      console.error("Error parsing dates:", error);
    }

    return existingDates.includes(date) || existingDates.includes(date.replace(/(\d\d)\/(\d\d)\/(\d{4})/, "$3-$1-$2"));
  }

  removeDate(event) {
    event.preventDefault();
    const dateElement = event.currentTarget.closest('.blacklisted-date-item');

    if (dateElement) {
      dateElement.remove();
    }
    this.updateHiddenField();

    const dateValue = dateElement.getAttribute("data-date-value");
    const hiddenInput = this.element.querySelector(`input[name="drug_test_request[skipped_dates][]"][value="${dateValue}"]`);
    if (hiddenInput) {
      hiddenInput.remove();
    }
  }

  appendBlacklistedDate(date) {
    const formattedDate = new Date(date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });

    const dateElement = document.createElement('span');
    dateElement.classList.add("badge", "badge-pill", "badge-primary", "blacklisted-date-item" , 'mr-2');
    dateElement.setAttribute("data-date-value", date);
    dateElement.innerHTML = `${formattedDate} <a href="#" class="ml-2 text-white" data-action="click->drug-test-request-schedule#removeDate" data-date-value="${date}">X</a>`;

    this.blacklistedDatesTarget.appendChild(dateElement);
    this.updateHiddenField();
  }

  updateHiddenField() {
    const dateSpans = Array.from(this.blacklistedDatesTarget.querySelectorAll(".blacklisted-date-item"));
    const dates = dateSpans.map(el => el.getAttribute("data-date-value"));

    this.datesHiddenFieldTarget.value = JSON.stringify(dates);
  }

  initializeDatePicker() {
    const datePicker = this.textTagTarget;
    const startDate = JSON.parse($(datePicker).data('startDate'));
    if (datePicker) {
      $(datePicker).datepicker(
        {
          autoclose: true,
          startDate: new Date(startDate)
        }
      ).on('changeDate', function() {
        $(this).datepicker('hide');
      });
    }
    const hiddenField = this.datesHiddenFieldTarget;
    hiddenField.value = JSON.stringify(hiddenField.value.split(" "));
  }

  showWarningPopUp(event){
    event.preventDefault();
    $('#edit_warning_modal').modal('show');
  }

  submitEditForm(){
    $('#edit_warning_modal').modal('hide');
    $('.edit_drug_test_request_schedule').submit();
  }

  closeWarningPopUp(){
    $('#update-schedule-btn').removeAttr('disabled');
  }
  
  recurringSelectDropdown(event){
    setTimeout(this.hideExtraOptions, 500);
  }

  hideExtraOptions() {
    $('#rs_frequency option[value=Yearly]').remove();
    $('#rs_frequency option[value=Daily]').remove();
  }

  setupTooltips() {
    $('[data-toggle="tooltip"]').tooltip();
  }
  
  restrictNegativeValues(event) {
    const input = event.target;

    if (input.value < 0) {
      input.value = 0;
    }
  }
}
